import type { FC } from "react";
import { SimpleField, translate } from "@shape/reef-shared";

interface RejectedReviewDetailsProps {
  comments?: string | null;
  title: string;
  userName?: string | null;
}

export const RejectedReviewDetails: FC<RejectedReviewDetailsProps> = ({
  comments,
  title,
  userName,
}) => (
  <div className="rejected-by">
    <h4>{title}</h4>

    <div>
      <SimpleField label={translate("formGeneric.name")} content={userName ?? undefined} />

      <SimpleField label={translate("generic.comments")} content={comments ?? undefined} />
    </div>
  </div>
);
